import { TREATMENT_SERVICE_MIX_LABELS } from "../shared/sharedMetrics";

// Enriquecimento partilhado pelas tabelas "Tratamentos Iniciados" e "+ Por Vir": a partir das sessões
// (ordenadas por start_date) constrói-se a primeira sessão de cada tratamento e daí as linhas do drill.
export const FIRST_SESSION_ENRICHMENT_FIELDS =
    "start_date,status,service.name,clinic_id.name,treatment.id,treatment.client.user_id.first_name,treatment.client.user_id.last_name";

type FirstSessionItem = {
    start_date: string;
    status: string;
    service?: { name?: string | null } | null;
    clinic_id?: { name?: string | null } | null;
    treatment?: { id?: number | string | null; client?: { user_id?: { first_name?: string | null; last_name?: string | null } | null } | null } | null;
};

export const firstSessionByTreatmentIdFromItems = (items: Array<FirstSessionItem>) => {
    const firstSessionByTreatmentId = new Map<number, FirstSessionItem>();
    items.forEach((session) => {
        const treatmentId = Number(session.treatment?.id);
        if (!firstSessionByTreatmentId.has(treatmentId)) {
            firstSessionByTreatmentId.set(treatmentId, session);
        }
    });
    return firstSessionByTreatmentId;
};

type TreatmentWithFirstSession = { treatmentId: number | string; firstSessionDate: string };

export const treatmentServiceMixChips = (rows: Array<{ servicesLabel: string | null }>) => {
    const chips = [TREATMENT_SERVICE_MIX_LABELS.nfbOnly, TREATMENT_SERVICE_MIX_LABELS.psyOnly, TREATMENT_SERVICE_MIX_LABELS.both].map((label) => {
        const labelCount = rows.filter((row) => row.servicesLabel === label).length;
        const chip = `${label}: ${labelCount}`;
        return chip;
    });
    return chips;
};

export const treatmentFirstSessionDrillRows = (
    treatments: Array<TreatmentWithFirstSession>,
    firstSessionByTreatmentId: Map<number, FirstSessionItem>,
    sessionStatusLabels: Record<string, string>,
    servicesLabelByTreatmentId: Map<number, string>
) => {
    const rows = treatments.map((treatment) => {
        const firstSession = firstSessionByTreatmentId.get(Number(treatment.treatmentId));
        const user = firstSession?.treatment?.client?.user_id;
        const clientName = user ? [user.first_name, user.last_name].filter(Boolean).join(" ").trim() : "";
        const row = {
            id: treatment.treatmentId,
            clientName: clientName || `Tratamento #${treatment.treatmentId}`,
            firstSessionDate: treatment.firstSessionDate,
            clinicName: firstSession?.clinic_id?.name ?? null,
            serviceName: firstSession?.service?.name ?? null,
            statusLabel: firstSession ? sessionStatusLabels[firstSession.status] || firstSession.status : null,
            servicesLabel: servicesLabelByTreatmentId.get(Number(treatment.treatmentId)) ?? null,
        };
        return row;
    });
    return rows;
};

type DrillRow = { firstSessionDate: string | null; clinicName: string | null };

// Chips com a contagem por clínica (ex.: "Porto: 20", "Braga: 6"). Usado nos cartões de tratamentos e,
// via treatmentFirstSessionHeaderChips, no cabeçalho do drill-down.
export const treatmentClinicChips = (rows: Array<DrillRow>, clinicNamesToCount: Array<string>) => {
    const chips = clinicNamesToCount.map((clinicName) => {
        const clinicCount = rows.filter((row) => row.clinicName === clinicName).length;
        const chip = `${clinicName}: ${clinicCount}`;
        return chip;
    });
    return chips;
};

export const treatmentFirstSessionHeaderChips = (rows: Array<DrillRow>, todayIso: string, clinicNamesToCount: Array<string>) => {
    const startingTodayCount = rows.filter((row) => row.firstSessionDate?.slice(0, 10) === todayIso).length;
    const chips = [`A começar hoje: ${startingTodayCount}`, ...treatmentClinicChips(rows, clinicNamesToCount)];
    return chips;
};
